import BillingsComponent from '../../components/Billings/Billings'

const Billings = () => {
  return (
    <div>
      <BillingsComponent />
    </div>
  )
}

export default Billings
